import { useContext, useEffect, useState } from "react"

import { env } from "env"
import { LoggedOutPage } from "pages/LoggedOutPage"
import { LogoutPage } from "pages/LogoutPage"
import { Route, Routes } from "react-router-dom"
import { type ClientData } from "types"

import { ClientContext } from "context/ClientContext"

import { AppRoutes } from "utilities/constants"

import { LayoutProvider } from "./LayoutProvider"

export const Unauthenticated = () => {
  const { client } = useContext(ClientContext)

  const [clientData, setClientData] = useState<ClientData | undefined>()

  useEffect(() => {
    if (!env.DEV) {
      setClientData(client?.data ?? ({} as ClientData))
    } else {
      import("data/colleges").then(({ COLLEGES }) => {
        const activeCollege = COLLEGES.find(c => c.currentlyActive)!
        setClientData(activeCollege.data)
      })
    }
  }, [client])

  if (!clientData) {
    return null
  }

  return (
    <LayoutProvider clientData={clientData}>
      <Routes>
        <Route
          key={AppRoutes.logout}
          path={AppRoutes.logout}
          element={<LogoutPage />}
        />
        <Route
          key={AppRoutes.loggedOut}
          path={AppRoutes.loggedOut}
          element={<LoggedOutPage />}
        />
        <Route path="*" element={null} />
      </Routes>
    </LayoutProvider>
  )
}
